<template>
  <v-app :dark="isDark" :class="colorClass">
    <v-navigation-drawer v-model="drawer" fixed clipped app :dark="isDark" :class="colorClass">
      <v-list dense>
        <v-subheader>Usuário</v-subheader>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>face</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ userName }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider />
        <template v-for="(item, i) in menuItems">
          <v-divider v-if="item.divider" :key="i"></v-divider>

          <v-list-tile
            v-else
            :value="menuItemSelected === item"
            :key="i"
            @click="
              menuItemSelected = item
              item.action()
            "
          >
            <v-list-tile-action>
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app clipped-left dark color="primary" v-if="!inLoginPage">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="inValidationTabPage" icon @click="openProductsDialog">
        <v-icon>settings</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content>
      <v-slide-y-transition mode="out-in">
        <router-view />
      </v-slide-y-transition>
    </v-content>

    <v-snackbar
      class="my-stackbar"
      :color="snackbarColor"
      :timeout="3000"
      multi-line
      vertical
      top
      v-model="snackbarOpen"
    >
      <h2 class="text-xs-center">{{ snackbarMessage }}</h2>
    </v-snackbar>

    <products-config />
  </v-app>
</template>

<script>
import ProductsConfig from './components/configs/ProductsConfig'

export default {
  components: { ProductsConfig },
  data() {
    return {
      drawer: false,
      menuItems: [
        { icon: 'event', title: 'Eventos', selected: false, action: this.goEvents },
        { icon: 'assignment_ind', title: 'Validar', selected: false, action: this.goHome },
        { icon: 'history', title: 'Histórico', selected: false, action: this.goValidations },
        { divider: true },
        // { icon: 'settings_applications', title: 'Configurações', selected: false, action: this.goConfig },
        { icon: 'exit_to_app', title: 'Sair', selected: false, action: this.logout }
      ],
      menuItemSelected: {}
    }
  },
  computed: {
    inLoginPage() {
      return this.$route.name === 'Login'
    },
    inValidationTabPage() {
      return this.$route.name === 'ValidationTab'
    },
    title() {
      return this.$store.getters.currentPage
    },
    snackbarOpen: {
      get() {
        return this.$store.getters.snackbarOpen
      },
      set(value) {
        this.$store.dispatch('setSnackbarOpen', value)
      }
    },
    snackbarColor() {
      return this.$store.getters.snackbarColor
    },
    snackbarMessage() {
      return this.$store.getters.snackbarMessage
    },
    userName() {
      return this.$store.getters.userName
    },
    colorClass() {
      return this.$store.getters.colorClass
    },
    isDark() {
      return this.$store.getters.isDark
    }
  },
  methods: {
    goHome() {
      this.closeMenu()
      this.$router.push('/')
    },
    goEvents() {
      this.closeMenu()
      this.$router.push('/events')
    },
    goValidations() {
      this.closeMenu()
      this.$router.push('/validations')
    },
    goConfig() {
      this.closeMenu()
      this.$router.push('/config')
    },
    logout() {
      this.$store.dispatch('doLogout')
      this.$router.push('/login')
      this.closeMenu()
    },
    closeMenu() {
      this.drawer = false
    },
    openProductsDialog() {
      this.$store.dispatch('openProductsConfigDialog')
    }
  }
}
</script>

<style>
* {
  padding: 0px;
  margin: 0px;
}
.my-stackbar {
  width: 100vw;
}

.my-stackbar > div {
  width: 100vw;
  max-width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue